import React from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Alert = ({ isOpen, reset, content = "", handleCancel = reset }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        reset();
        navigate("/ownerDashboard");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          style={{
            fontFamily: "Segoe UI",
            fontSize: 20,
            fontWeight: 600,
            textAlign: "left",
          }}
        >
          {t("components.alert.title")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontFamily: "Segoe UI",
            fontSize: 18,
            fontWeight: 400,
            textAlign: "left",
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          style={{
            alignSelf: "center",
            width: 86,
            height: 32,
            marginLeft: 21,
            marginBottom: 3,
            display: "flex",
            borderRadius: 4,
          }}
          onClick={() => {
            handleCancel && handleCancel();
            reset();
            navigate("/ownerDashboard");
          }}
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("components.alert.text01")}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
